import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';
Vue.use(Vuex);
const store = new Vuex.Store({
	state: {
		infoName: 'a',
		fullscreenLoading: false,
		loginStatus: false,
		isLogin: false,
		userInfo: {},
		btnVal: '',
	},
	mutations: {
		updateInfoName(state, rel) {
			state.infoName = rel;
		},
		editLoad(state, rel) {
			state.fullscreenLoading = rel;
		},
		editLoginStatus(state, rel) {
			state.loginStatus = rel;
		},
		editBtnVal(state, rel) {
			state.btnVal = rel;
		},
		editIsLogin(state, rel) {
			state.isLogin = rel;
		},
		editUserInfo(state, rel) {
			state.userInfo = rel;
		}
	},
	actions: {}
})
export default store;


// WEBPACK FOOTER //
// ./src/store/index.js